// extracted by mini-css-extract-plugin
export default {"clients":"clients_clients__hSE9O"};